// extracted by mini-css-extract-plugin
export default {"stroke":"BackgroundStroke_stroke__KUnRN"};